module.exports = __webpack_public_path__ + "static/media/62-bbed-bach.d04843c4.jpg";